module.exports = __webpack_public_path__ + "static/media/lock_icon.fde623b9.svg";